<template>
  <div>
    <vs-icon
      icon="thumb_up"
      class="cursor material-icons text-success"
      title="Aprobado"
      v-if="item.accion === 'Aprobado'"
    >
    </vs-icon>
    <vs-icon
      icon="thumb_down"
      class="cursor material-icons text-danger"
      title="Rechazado"
      v-if="item.accion === 'Rechazado'"
    >
    </vs-icon>
    <vs-icon
      icon="schedule"
      class="cursor material-icons orange"
      title="Pendiente"
      v-if="item.accion === 'Pendiente'"
    >
    </vs-icon>
    <vs-icon
      icon="schedule"
      class="cursor material-icons text-success"
      title="Pendiente"
      v-if="item.accion === 'Procesando'"
    >
    </vs-icon>
  </div>
</template>

<script>
export default {
  name: 'ApprovalsIcons',
  props: ['item']
};
</script>

<style scoped>
.cursor {
  cursor: default;
}
</style>
